import api from "../..";
import type {
  DeleteGoldenChallengeChainParams,
  DeleteGoldenChallengeParams,
} from "./types";

export const deleteGoldenChallenge = async ({ id }: DeleteGoldenChallengeParams): Promise<boolean> => {

  return await api.delete(`/admin/golden-challenges/${id}/`)
  .then(() => true)
  .catch(() => false);
};

export const deleteGoldenChallengeChain = async ({ id }: DeleteGoldenChallengeChainParams): Promise<boolean> => {

  return await api.delete(`/admin/challenges/chains/${id}/`)
  .then(() => true)
  .catch(() => false);
};
